export default __webpack_public_path__ + "static/media/schedule-png.d48a749a.png";